import { useState, useEffect, useCallback } from 'react'
import { Grid, Hidden } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'

import { Card, CardContent } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SpreadsTable from './SpreadsTable'

import PageTitle from '../../../Misc/PageTitle'
import { toast } from 'react-toastify'
import ButtonWrapper from '../../../FormUI/ButtonWrapper/ButtonWrapper'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import MerchantMenu from '../MerchantMenu'
import { Stack } from '@mui/material'
import MerchantAlias from '../MerchantAlias'
import MerchantSubmenu from '../MerchantSubmenu'
import useIsMounted from '../../../../hooks/useIsMounted'
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate'


export default function SpreadsList() {
    const { t } = useTranslation()

    const navigate = useNavigate()

    const isMounted = useIsMounted()

    const api = useAxiosPrivate()

    const { userId } = useParams()

    const [params, setParams] = useState({})

    const [loading, setLoading] = useState(true)

    const [data, setData] = useState([])

    const [meta, setMeta] = useState({
        total_pages: 1,
        current_page: 1
    })

    const handleOnPageChange = (e, page) => {
        setMeta({ ...meta, current_page: page })
        setParams({ ...params, page: page })
    }

    const retrieveData = useCallback(() => {
        setData([])

        api.get(`/internal/merchants/${userId}/spreads/`, { params: params })
            .then(({ data: { data, meta } }) => {
                if (isMounted()) {
                    const custom = data.filter(d => !d.is_global)

                    setMeta(meta)

                    setData([
                        ...custom, ...data.filter(d => !custom.filter(c => c.country === d.country).length)
                    ])
                }
            })
            .catch(() => isMounted() && toast.error(t('Something went wrong')))
            .finally(() => isMounted() && setLoading(false))
    }, [params, userId, t, api, isMounted])

    const handleRemove = (id) => {
        return api.delete(`/internal/merchants/${userId}/spreads/${id}/`)
            .then(() => {
                if (isMounted()) {
                    setData(data.filter(m => m.id !== id))
                    toast.success(t('Spread has been deleted'))
                }
            })
            .catch((error) => isMounted() && toast.error(t('Something went wrong')))
    }

    useEffect(() => {
        const init = () => {
            setLoading(true)
            retrieveData()
        }

        init()
    }, [params, retrieveData])

    return (
        <>
            <Card>
                <CardContent>
                    <Stack direction="row" justifyContent="space-between" spacing={2}>
                        <PageTitle title={t('Merchant spreads')} />

                        <Hidden xlUp={true}>
                            {userId ? <MerchantMenu id={userId} /> : ''}
                        </Hidden>
                    </Stack>

                    <MerchantAlias />

                    <Grid container spacing={2} mt={2} mb={2}>
                        <Grid item xs={6}></Grid>
                        <Grid item xs={6} sx={{
                            textAlign: 'right'
                        }}>
                            <ButtonWrapper
                                variant="text"
                                size="small"
                                onClick={() => navigate('/merchants')}
                                className="base__btn-action"
                                startIcon={<ArrowBackIcon />}>{t('Go back')}</ButtonWrapper>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={12} xl={2}>
                            <MerchantSubmenu current='spreads' id={userId} />
                        </Grid>
                        <Grid item xs={12} xl={10}>
                            <SpreadsTable
                                data={data}
                                pages={meta.total_pages}
                                page={meta.current_page}
                                loading={loading}
                                handleOnPageChange={handleOnPageChange}
                                handleRemove={handleRemove}
                                merchantId={userId}
                            />
                        </Grid>
                    </Grid>

                </CardContent>
            </Card>
        </>
    )
}
